import { NavLink } from "react-router-dom";
import { Logo } from "@/components/Brand";

const linkCls = ({ isActive }) =>
  `rounded-full px-4 py-2 text-sm transition-colors duration-300 ${
    isActive ? "bg-ivory text-navy" : "text-ivory/70 hover:text-ivory"
  }`;

export const MemberHeader = () => (
  <header className="bg-navy">
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-5 py-4 sm:px-10">
      <Logo to="/" />
      <nav className="flex items-center gap-1">
        <NavLink to="/mon-compte" className={linkCls} data-testid="member-nav-account">
          Mon compte
        </NavLink>
      </nav>
    </div>
  </header>
);
